<div id="addAssetDialog" class="modal modal-med modal-dialog fade in" role="dialog" style="display: none;position:absolute !important" 
    appDraggable dragTarget="#addAssetDialog" dragHandle="#addAssetDialogHeader" data-backdrop="static" data-keyboard="false">
  <div class="modal-content">

    <!-- Header -->
    <div class="modal-header" id="addAssetDialogHeader">
      <button type="button" class="close" (click)="hide()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
      <h4 class="modal-title"><i class="fa fa-plus"></i> ASSIGN ASSET</h4>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-2">
          <label for="asset" class="labelRequired">Asset: </label>
        </div>
        <div class="col-sm-5">
          <input id="asset" type="text" class="form-control" placeholder="Search by Asset name..." autocomplete="off"
            [ngModel]="selectedAsset?.name || ''"
            (ngModelChange)="onInputChanged($event)"
            [typeahead]="availableAssets$"
            [typeaheadAsync]="true"
            [typeaheadOptionField]="'name'"
            (typeaheadOnSelect)="onAssetSelected($event)" 
            [typeaheadMinLength]="0"
            (focus)="trigger.next($any($event).target.value)"
            #trigger="ngModel"
            #assetInput
            />
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="onCancelClicked()"><i class="fa fa-ban"
          aria-hidden="true"></i> CANCEL</button>
      <button type="button" class="btn btn-primary" (click)="onAddClicked()"><i class="fa fa-refresh"
          aria-hidden="true"></i> ADD</button>
    </div>
  </div>
</div>